import { FeatureName, useIsFeatureEnabled } from '@gripp/shared-logic';
import {
  SlideAction,
  SlideLayout,
  useSlideLayout,
  ViewMode,
} from '@gripp/shared-ui';
import { StyleSheet, View } from 'react-native';
import { useNavigate, useParams } from 'react-router-dom';
import { ProductDetail } from './productDetail';
import { ProductsComponent } from './productsComponent';
import { ProductsFilters } from './productsFilters';

export const Product = () => {
  const isCropCircleEnabled = useIsFeatureEnabled(
    FeatureName.CropCircleRedesign
  );

  if (isCropCircleEnabled) {
    return <ProductBase />;
  }

  return <ProductOld />;
};

const ProductOld = () => {
  const { productId = '' } = useParams();

  return (
    <View style={styles.container}>
      <ProductDetail productId={productId} />
    </View>
  );
};

const ProductDetailWithSlideLayout = ({ productId }: { productId: string }) => {
  const { setColumnTitle } = useSlideLayout();
  return (
    <ProductDetail productId={productId} setColumnTitle={setColumnTitle} />
  );
};

const ProductBase = () => {
  const { productId = '' } = useParams();
  const navigate = useNavigate();

  const leftColumn = {
    title: 'product.list.products',
    mainComponent: <ProductsComponent />,
    headerComponent: <ProductsFilters />,
  };

  const rightColumn = {
    title: 'product.list.products',
    mainComponent: <ProductDetailWithSlideLayout productId={productId} />,
    showBackButton: true,
    backButtonTransition: SlideAction.SINGLE,
    onBackButtonPress: () => {
      navigate('/products');
    },
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
  },
});
